var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 form-group breadcrumb-container"},[_c('app-breadcrumb',{staticClass:"breadcrumb p-0",attrs:{"items":_vm.breadcrumbItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }